module.exports = __webpack_public_path__ + "share-dialog-warm.f3b69add.png";